module.exports = __webpack_public_path__ + "img/AI (2).8f0bb734.png";